<template>
    <div class="wrap">
        <!--banner-->
        <div class="bannerWrap">
            <div class="banner">
                <el-row type="flex" justify="space-between" align="middle">
                    <el-col :span="3"></el-col>
                    <el-col :span="18" class="page1Content">
                        <el-row>
                            <el-col :span="9" :offset="2" style="padding-top: 6%;">
                                <img src="../assets/img/banner/logo.svg" alt=""/>
                                <p class="content">
                                    团队深耕全球市场，为中国企业提供一站式出海营销方案<br>
                                    广告业务涵盖全球最主流的媒体<br>
                                    如：Facebook / line / Google / tiktok / …<br>
                                    致力于为客户量身定制最高转化的营销方案<br>
                                    服务于电商、游戏、应用等企业<br>
                                </p>
                            </el-col>
                            <el-col :span="9" :offset="1">
                                <img src="../assets/img/banner/banner.png" alt="" class="bannerImg"/>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="3"></el-col>
                </el-row>
            </div>
        </div>
        <!--服务优势 facebook 月活用户-->
        <div class="page" style="padding-top: 80px;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page1">
                    <div class="title">服务优势</div>
                    <div class="littleTitle">优质的渠道</div>
                    <div class="type">facebook 月活用户</div>
                    <div class="typeIntro">
                        依托 facebook 大数据营销，精准连接用户需求与买家，还拥有返点政策，一对一服务
                    </div>
                    <el-row class="imgWrap">
                        <el-col :span="24" class="facebookBox">
                            <img src="../assets/img/page1/facebook.svg" alt=""/>
                            <img src="../assets/img/page1/facebook_logo.svg" alt="" class="logo"/>
                            <img src="../assets/img/page1/facebook_number_cn.svg" alt="" class="num"/>
                            <img src="../assets/img/page1/facebook_phone.png" alt="" class="phone"/>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--Line 用户量级-->
        <div class="page" style="background: rgba(231, 241, 253, .5);padding-top: 90px;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page2">
                    <div class="type">Line 用户量级</div>
                    <div class="typeIntro">
                        智能精准投放，智能学习投放优化，大数据分析服务，更智慧的信息应用控制中心
                    </div>
                    <el-row class="imgWrap">
                        <el-col :span="24" class="lineBox">
                            <img src="../assets/img/page2/line.png" alt=""/>
                            <img src="../assets/img/page2/line_number_cn1.svg" alt="" class="num"/>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--Google 流量源-->
        <div class="page" style="padding: 90px 0 120px;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page3">
                    <div class="type">Google 流量源</div>
                    <div class="typeIntro" style="margin-bottom: 64px;">
                        google 大数据营销、覆盖你想要找的用户多渠道并行覆盖海外优质流量
                    </div>
                    <el-row class="imgWrap" type="flex" justify="center">
                        <el-col :span="9">
                            <img src="../assets/img/page3/google.png" alt=""/>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--优势-->
        <div class="page" style="background: black">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page4">
                    <el-row type="flex" justify="center">
                        <el-col :span="8" style="position: relative;z-index: 100">
                            <div class="left">
                                <div class="logoWrap">
                                    <img src="../assets/img/page4/tiktok logo@2x.png" alt="" class="logo"/>
                                    <img src="../assets/img/page4/tiktok@2x.png" alt="" class="logoText"/>
                                    <span class="advantage">优势</span>
                                </div>
                                <p class="advantage">
                                    TikTok 是抖音海外版，在日本、韩国、印度、泰国、美国、俄罗斯以及我国台湾省等诸多海外国家和地区拥有广泛的用户群体
                                </p>
                                <ul class="advantage">
                                    <li>
                                        1. 用户规模大且分布广
                                    </li>
                                    <li>
                                        2. 产品粘性强
                                    </li>
                                    <li>
                                        3. 广告定向精准
                                    </li>
                                    <li>
                                        4. 价格美丽
                                    </li>
                                    <li>
                                        5. 优秀的广告体验
                                    </li>
                                </ul>
                            </div>
                        </el-col>
                        <el-col :span="10" style="position: relative;z-index: 1">
                            <img src="../assets/img/page4/Advantage@2x.png" alt="" class="right"/>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--运营商（海外增值服务提供商）-->
        <div class="page" style="padding: 90px 0 0;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page5">
                    <div class="type" style="margin-bottom: 0;">运营商（海外增值服务提供商）</div>
                    <el-row class="imgWrap">
                        <el-col :span="24" class="OperatiorsBox">
                            <img src="../assets/img/page5/Operatiors_en.png" alt=""/>
                            <div class="OperatiorsCon">
                                <el-row type="flex" justify="space-around">
                                    <el-col :span="8">
                                        <div class="leftCon">
                                            <div class="conTitle">覆盖众多国家：</div>
                                            <p class="conText">
                                                主服务东南亚及中东、欧洲用户数千万，各国落地办事处直接对接运营商关系，在海外有丰富的运营商资源及本地优势，能够帮助合作伙伴将优质的内容资源出海，通过运营商渠道实现收益，高额回报
                                            </p>
                                        </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="centerCon">
                                            <div class="conTitle">优质渠道流量：</div>
                                            <p class="conText">
                                                致力于移动业务推广服务，通过获取Google, Facebook优质流量进行业务推广，实现最佳推广效果。
                                            </p>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="rightCon">
                                            <div class="conTitle">优质内容：</div>
                                            <p class="conText">
                                                作为优质的内容服务商，整合优质的内容资源，<br>
                                                包括游戏、视频、音乐、图片、动漫等资源，可以为用户提供游戏娱乐、视听、交友、资讯等服务。
                                            </p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--海外业务团队优势-->
        <div class="page" style="background: rgba(231, 241, 253, .5);">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page6">
                    <el-row class="imgWrap" type="flex" justify="start">
                        <el-col :span="9">
                            <img src="../assets/img/page6/illustrator.png" alt=""/>
                        </el-col>
                        <el-col :span="14" :offset="1" style="padding-top: 7%;">
                            <div class="title">海外业务团队优势</div>
                            <p>团队拥有超过10年的海外业务经验，团队精英来自于AVAZU / 猎豹 / 百度 / 华为，在移动应用 / 游戏 / 跨境电商等领域都取得了不俗的成绩</p>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--成功案例-->
        <div class="page" style="padding: 78px 0 150px;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page7">
                    <el-row class="imgWrap exampleBox">
                        <div class="title">成功案例</div>
                        <el-carousel indicator-position="none" height="480px" :interval="5000"
                                     style="margin-top: 54px;">
                            <el-carousel-item>
                                <el-col class="example" style="padding: 0 80px;">
                                    <el-row type="flex" justify="space-between">
                                        <el-col :span="7" style="display: flex;align-items: flex-end;">
                                            <img src="../assets/img/page7/eLong@2x.png" alt="" style="width: 95%;"/>
                                        </el-col>
                                        <el-col :span="15" :offset="2" style="padding-top: 65px;" class="yl">
                                            <p class="bigT">艺龙旅行</p>
                                            <p class="smallT">策略</p>
                                            <p class="content">
                                                在投放艺龙旅行的过程中，汇集了几乎国内顶尖开发者（如百度、360、久邦等），采用 in-app 的形式推送广告，此类流量约占50%，
                                                剩余40%的流量采用自有 DSP 平台及自有的 mediabuy 团队，<br>
                                                剩余10%则放给了经验最为丰富，实力最为强劲的个人渠道，<br>
                                                多管齐下，取得了较为良好的投放效果
                                            </p>
                                            <p class="smallT">结果</p>
                                            <p class="content">
                                                截止2017年暑假期间，艺龙旅行在我方的投放量级，每日量级稳定在 2000-3000 之间，<br>
                                                在依据客户需求进行定向优化后，我方总体质量等级稳定在 1-2 之间
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-carousel-item>
                            <el-carousel-item>
                                <el-col class="example">
                                    <el-row type="flex" justify="space-between">
                                        <el-col :span="9" style="display: flex;align-items: flex-end;">
                                            <img src="../assets/img/page7/Hornet's Nest@2x.png" alt=""
                                                 style="display: block;width: 95%;"/>
                                        </el-col>
                                        <el-col :span="15" style="padding-top: 65px;" class="yl">
                                            <p class="bigT">马蜂窝</p>
                                            <p class="smallT">策略</p>
                                            <p class="content">
                                                马蜂窝作为一款 OTA 产品，根据中国区数据进行分析，马蜂窝在 Android 和 iOS
                                                目前已经有一定的量级；但是对标竞品，马蜂窝仍有很大潜力可以进行发挥。<br>
                                                2018年马蜂窝预计增加 3000万
                                                用户，所以在推广力度方面进一步加强。我方为增量提供支撑，首先针对主打酒店进行用户诉求分析与竞品分析，依靠自有团队及资源优势针对
                                                iOS/Android 平台进行基准测试
                                            </p>
                                            <p class="smallT">结果</p>
                                            <p class="content">
                                                IOS 测试平稳后，日均新增为 2500-3500，<br>
                                                Android 测试平稳后，日均新增为 3000-4000<br>
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-carousel-item>
                            <el-carousel-item>
                                <el-col class="example" style="padding: 0 80px;align-items: baseline">
                                    <el-row type="flex" justify="space-between" style="width: 100%;">
                                        <el-col :span="7" style="display: flex;">
                                            <img src="../assets/img/page7/zetianji.png" alt=""
                                                 style="padding-top: 20px;"/>
                                        </el-col>
                                        <el-col :span="15" :offset="2" style="padding-top: 11%;" class="yl">
                                            <p class="bigT">游戏</p>
                                            <p class="smallT">择天记</p>
                                            <p class="content">
                                                《择天记》手游是由三七互娱自主研发，倾力打造的首款3DMMO手游巨作，改编自腾讯文学旗下
                                                作者猫腻的同名小说。完美还原电视剧小说人物、剧情和场景，在人妖魔共存的世界里拉开了陈长
                                                生逆天改命的盛大序幕，游戏中玩家将以长生师兄、师姐的身份出现，与一群志同道合的小伙伴陪 伴长生修行改命，见证其成长路程
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-carousel-item>
                            <el-carousel-item>
                                <el-col class="example" style="padding: 0 80px 0 0;align-items: center">
                                    <el-row type="flex" justify="space-between">
                                        <el-col :span="8" style="display: flex;">
                                            <img src="../assets/img/page7/zhuxian.png" alt=""
                                                 style="width: 125%;margin-left: -20%;"/>
                                        </el-col>
                                        <el-col :span="15" :offset="2" style="padding-top: 6%;" class="yl">
                                            <p class="bigT">游戏</p>
                                            <p class="smallT">诛仙</p>
                                            <p class="content">
                                                《诛仙手游》是完美世界（北京）软件 科 技 发 展 有 限 公 司 研 发 的 一 款 3DMMORPG仙侠手游。该作于2016年
                                                08月10日正式公测
                                                《诛仙手游》部分场景、人设、玩法等 诸多方面，依旧沿用《诛仙》端游设计， 让诛仙IP粉重温当年的情怀体验
                                                该作以萧鼎所著同名仙侠小说《诛仙》 的神话故事为背景，讲述了鬼王想复活兽 神并颠覆青云的故事
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-carousel-item>
                            <el-carousel-item>
                                <el-col class="example" style="padding: 0 80px;align-items: baseline">
                                    <el-row type="flex" justify="space-between" style="width: 100%;">
                                        <el-col :span="7">
                                            <img src="../assets/img/page7/heisha.png" alt=""
                                                 style="padding-top: 20px;"/>
                                        </el-col>
                                        <el-col :span="15" :offset="2" style="padding-top: 11%;" class="yl">
                                            <p class="bigT">Black Shark</p>
                                            <p class="smallT">黑鲨手机</p>
                                            <p class="content">
                                                投放地区：东南亚+亚洲<br>
                                                投放时间：2019年11月至今<br>
                                                投放消耗：10W+USD<br>
                                                广告目标：冲刺电商高峰季（双十一、发布会等）、参与品牌升级投放计划、提高品牌展示流量<br>
                                                投放计划：Google/Youtobe上投放的品牌视频、展示广告和关键词搜索广告<br>
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-carousel-item>
                            <el-carousel-item>
                                <el-col class="example" style="padding: 0 80px;align-items: baseline">
                                    <el-row type="flex" justify="space-between" style="width: 100%;">
                                        <el-col :span="7" style="display: flex;">
                                            <img src="../assets/img/page7/cheboshi.png" alt=""
                                                 style="padding-top: 20px;width: 100%;"/>
                                        </el-col>
                                        <el-col :span="15" :offset="2" style="padding-top: 11%;" class="yl">
                                            <p class="bigT">Autodoc</p>
                                            <p class="smallT">车博士</p>
                                            <p class="content">
                                                应用分类：购物（应用）<br>
                                                投放地区：欧洲（德国、西班牙、法国、瑞典、瑞士、荷兰为主）<br>
                                                投放时间内：2018年合作至今<br>
                                                主营业务：在线汽车零部件销售<br>
                                            </p>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-carousel-item>
                        </el-carousel>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--合作伙伴-->
        <div class="page" style="background: rgba(231, 241, 253, .5);padding: 81px 0 90px;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page8">
                    <div class="title" style="margin-bottom: 21px;">合作伙伴</div>
                    <el-row class="imgWrap" type="flex" align="middle" justify="center">
                        <el-col :span="24">
                            <img src="../assets/img/page8/cooperation.png" alt=""/>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--公司简介-->
        <div class="page company-profile-page" v-if="false">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="companyProfile">
                    <div class="title" style="margin-bottom: 21px;">公司简介</div>
                    <div class="companyProfileCard">
                        <p><strong>公司简介：</strong>潮州市六翎体育文化传播有限公司成立于2017年10月，是专注以精准营销和互联网生态产品运营为核心的综合互联网营销推广服务商。通过整合全网优质媒体资源，并结合智能数据模型和AI标签算法，向企业提供包括流量矩阵搭建运营、媒介流量采买、投放模型设计、产品营销策划、数据监控分析、效果运营等多层次服务，目前主要为企业提供出海应用推广服务</p>
                        <p><strong>地址：</strong>潮州市潮安区龙湖镇银湖村鹳巢北路1号铺面</p>
                    </div>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--联系我们-->
        <div class="page contact-page" style="background: black;padding: 55px 0 152px;">
            <el-row type="flex" justify="space-between">
                <el-col :span="3"></el-col>
                <el-col :span="18" class="page9">
                    <div class="title" style="margin-bottom: 21px;color: #fff">联系我们</div>
                    <div class="contactUs">
                        <img src="../assets/img/page9/contact us pic@2x.png"/>
                        <div>
                            <span>Hochitlai</span>
                            <span>hochitlai@gmail.com</span>
                            <span>13902793773</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
            <a class="beian-link" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">粤ICP备2021112913号</a>
        </div>
    </div>
</template>

<script>
import mixins from "@/assets/page.js"

export default {
    name: "index-zh",
    mixins: [mixins],
}
</script>

<style lang="scss" scoped>
@import "../assets/page.scss";

.page4 {
    .left {
        ul {
            display: flex;
            flex-direction: column;
            width: 450px;

            li {
                display: flex;
                align-items: center;
                width: 100%;
                height: 60px;
                margin-bottom: 30px;
                font-size: 16px;
                color: #FFFFFF;
                letter-spacing: 0.27px;
                text-align: justify;

                &:nth-child(1) {
                    padding-left: 75px;
                    background: url("../assets/img/page4/1cn.png");
                    background-size: 100% 100%;
                }

                &:nth-child(2) {
                    padding-left: 58%;
                    align-self: flex-end;
                    background: url("../assets/img/page4/2cn.png");
                    background-size: 100% 100%;
                }

                &:nth-child(3) {
                    padding-left: 75px;
                    background: url("../assets/img/page4/3cn.png");
                    background-size: 100% 100%;
                }

                &:nth-child(4) {
                    padding-left: 64%;
                    align-self: flex-end;
                    background: url("../assets/img/page4/4cn.png");
                    background-size: 100% 100%;
                }

                &:nth-child(5) {
                    padding-left: 75px;
                    margin-bottom: 0;
                    background: url("../assets/img/page4/5cn.png");
                    background-size: 100% 100%;
                }
            }
        }

    }
}
</style>
